(function () {
  function iniciarCatalogo(seccion) {
    if (seccion.dataset.iniciado === 'true') return;
    seccion.dataset.iniciado = 'true';

    var idSeccion = seccion.getAttribute('data-section-id');
    var panelAbierto = false;
    var temporizadorPrecio = null;

    function contenedorActual() {
      return seccion.querySelector('.catalogo__contenedor');
    }

    function formularioActual() {
      return seccion.querySelector('[data-formulario]');
    }

    function construirUrl() {
      var formulario = formularioActual();
      var base = (formulario && formulario.getAttribute('action')) || window.location.pathname;
      var datos = formulario ? new URLSearchParams(new FormData(formulario)) : new URLSearchParams();
      var orden = seccion.querySelector('[data-orden]');
      if (orden && orden.value) datos.set('sort_by', orden.value);
      var query = datos.toString();
      return query ? base + '?' + query : base;
    }

    function pintarPreciosIniciales() {
      seccion.querySelectorAll('[data-precio]').forEach(function (grupo) {
        var minimo = grupo.querySelector('[data-precio-min]');
        var maximo = grupo.querySelector('[data-precio-max]');
        if (minimo && maximo) pintarRelleno(grupo, minimo, maximo);
      });
    }

    function pintarRelleno(grupo, minimo, maximo) {
      var relleno = grupo.querySelector('[data-precio-relleno]');
      var etiquetaMin = grupo.querySelector('[data-precio-etiqueta-min]');
      var etiquetaMax = grupo.querySelector('[data-precio-etiqueta-max]');
      var tope = parseFloat(grupo.dataset.tope) || 1;
      var desde = Math.min(parseFloat(minimo.value), parseFloat(maximo.value));
      var hasta = Math.max(parseFloat(minimo.value), parseFloat(maximo.value));

      if (relleno) {
        relleno.style.left = (desde / tope) * 100 + '%';
        relleno.style.width = ((hasta - desde) / tope) * 100 + '%';
      }
      if (etiquetaMin) etiquetaMin.textContent = formatearPrecio(desde);
      if (etiquetaMax) etiquetaMax.textContent = formatearPrecio(hasta);
    }

    function formatearPrecio(valor) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'es-ES', {
          style: 'currency',
          currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR',
          maximumFractionDigits: 0
        }).format(valor);
      } catch (error) {
        return valor;
      }
    }

    function abrirPanel() {
      var panel = seccion.querySelector('[data-panel-filtros]');
      var velo = seccion.querySelector('[data-velo-filtros]');
      if (!panel || !velo) return;
      panelAbierto = true;
      velo.hidden = false;
      window.requestAnimationFrame(function () {
        velo.classList.add('catalogo__velo--visible');
        panel.classList.add('catalogo__lateral--abierto');
      });
      document.body.style.overflow = 'hidden';
    }

    function reabrirPanelSinAnimacion() {
      var panel = seccion.querySelector('[data-panel-filtros]');
      var velo = seccion.querySelector('[data-velo-filtros]');
      if (!panel || !velo) return;
      panel.classList.add('catalogo__lateral--sin-transicion');
      velo.hidden = false;
      velo.classList.add('catalogo__velo--visible');
      panel.classList.add('catalogo__lateral--abierto');
      document.body.style.overflow = 'hidden';
      void panel.offsetWidth;
      panel.classList.remove('catalogo__lateral--sin-transicion');
    }

    function cerrarPanel() {
      var panel = seccion.querySelector('[data-panel-filtros]');
      var velo = seccion.querySelector('[data-velo-filtros]');
      if (!panel || !velo) return;
      panelAbierto = false;
      velo.classList.remove('catalogo__velo--visible');
      panel.classList.remove('catalogo__lateral--abierto');
      document.body.style.overflow = '';
      window.setTimeout(function () {
        if (!panel.classList.contains('catalogo__lateral--abierto')) velo.hidden = true;
      }, 320);
    }

    function actualizar(url, guardarHistorial) {
      var contenedor = contenedorActual();
      if (!contenedor || !idSeccion) {
        window.location.href = url;
        return;
      }

      var separador = url.indexOf('?') === -1 ? '?' : '&';
      var urlSeccion = url + separador + 'section_id=' + idSeccion;

      contenedor.classList.add('catalogo__contenedor--cargando');

      fetch(urlSeccion)
        .then(function (respuesta) {
          if (!respuesta.ok) throw new Error('no se pudo actualizar el catálogo');
          return respuesta.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nuevoContenedor = doc.querySelector('.catalogo__contenedor');
          if (!nuevoContenedor) throw new Error('respuesta sin contenido reconocible');

          contenedorActual().innerHTML = nuevoContenedor.innerHTML;
          contenedorActual().classList.remove('catalogo__contenedor--cargando');

          if (guardarHistorial) {
            window.history.pushState({ catalogoBarber: true }, '', url);
          }

          pintarPreciosIniciales();

          if (panelAbierto) {
            reabrirPanelSinAnimacion();
          }
        })
        .catch(function () {
          window.location.href = url;
        });
    }

    function enviarFormulario() {
      actualizar(construirUrl(), true);
    }

    seccion.addEventListener('change', function (evento) {
      if (evento.target.matches('[data-envio-automatico]') || evento.target.matches('[data-orden]')) {
        enviarFormulario();
      }
    });

    seccion.addEventListener('input', function (evento) {
      if (!evento.target.matches('[data-precio-min], [data-precio-max]')) return;
      var grupo = evento.target.closest('[data-precio]');
      var minimo = grupo.querySelector('[data-precio-min]');
      var maximo = grupo.querySelector('[data-precio-max]');
      if (parseFloat(minimo.value) > parseFloat(maximo.value)) {
        if (evento.target === minimo) {
          minimo.value = maximo.value;
        } else {
          maximo.value = minimo.value;
        }
      }
      pintarRelleno(grupo, minimo, maximo);
    });

    seccion.addEventListener('change', function (evento) {
      if (!evento.target.matches('[data-precio-min], [data-precio-max]')) return;
      window.clearTimeout(temporizadorPrecio);
      temporizadorPrecio = window.setTimeout(enviarFormulario, 500);
    });

    seccion.addEventListener('click', function (evento) {
      if (evento.target.closest('[data-abrir-filtros]')) {
        abrirPanel();
        return;
      }
      if (evento.target.closest('[data-cerrar-filtros]')) {
        cerrarPanel();
        return;
      }
      if (evento.target === seccion.querySelector('[data-velo-filtros]')) {
        cerrarPanel();
        return;
      }

      var enlaceNavegable = evento.target.closest('.catalogo__pagina, .catalogo__pastilla, .catalogo__vacio-boton');
      if (enlaceNavegable && enlaceNavegable.tagName === 'A' && enlaceNavegable.href) {
        evento.preventDefault();
        actualizar(enlaceNavegable.href, true);
        return;
      }

      var botonCarrito = evento.target.closest('[data-anadir-carrito]');
      if (botonCarrito && !botonCarrito.disabled) {
        var variantId = botonCarrito.getAttribute('data-variant-id');
        var etiquetaBoton = botonCarrito.querySelector('span');
        var textoOriginal = etiquetaBoton ? etiquetaBoton.textContent : botonCarrito.textContent;
        botonCarrito.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function (respuesta) {
            if (!respuesta.ok) throw new Error('cart add failed');
            return respuesta.json();
          })
          .then(function () {
            if (etiquetaBoton) etiquetaBoton.textContent = 'Añadido';
            botonCarrito.classList.add('is-added');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            window.setTimeout(function () {
              if (etiquetaBoton) etiquetaBoton.textContent = textoOriginal;
              botonCarrito.classList.remove('is-added');
              botonCarrito.disabled = false;
            }, 1800);
          })
          .catch(function () {
            if (etiquetaBoton) etiquetaBoton.textContent = textoOriginal;
            botonCarrito.disabled = false;
          });
      }
    });

    document.addEventListener('keydown', function (evento) {
      if (evento.key === 'Escape') cerrarPanel();
    });

    window.addEventListener('popstate', function () {
      actualizar(window.location.href, false);
    });

    pintarPreciosIniciales();
  }

  function iniciarTodo() {
    document.querySelectorAll('[data-catalogo]').forEach(iniciarCatalogo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodo);
  } else {
    iniciarTodo();
  }

  document.addEventListener('shopify:section:load', iniciarTodo);
})();